import React, {Fragment} from 'react'
import List from '../../../../components/Project/Resources/Vendors/List'
import VendorModal from '../../../../components/Project/Resources/Vendors/VendorsModal'

function Vendors(props) {
  return (
    <Fragment>
      <VendorModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

Vendors.propTypes = {}
Vendors.defaultProps = {}

export default Vendors
